import React from 'react';
import {Loader} from 'semantic-ui-react';
import InfiniteScroll from 'react-infinite-scroll-component';
import {Icon, Popup} from 'semantic-ui-react';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {connect} from 'react-redux';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {CURRENT_WORKLOAD_DASHBOARD} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class WorkloadTable extends React.Component {
  componentDidMount() {
    document.title = CURRENT_WORKLOAD_DASHBOARD;
  }

  render() {
    const {results} = this.props;

    let fundOppName;
    const cards = _.map(results, (result) => {
      const matchFundOpp = _.find(this.props.fundingOpps, (fundingOpportunity) => {
        return fundingOpportunity.fundingOpportunityNr == result.fundingOpportunityNumber;
      });
      fundOppName = _.get(matchFundOpp, 'fundingOpportunityName', '');
      if (!fundOppName) {
        fundOppName = _.get(result, 'fundingOpportunityName', '');
      }

      const matchIdToName = _.find(this.props.userObjs, (obj) => {
        return obj.userId == result.assignee;
      });
      const userIdEmail = _.get(matchIdToName, 'emailAdr', '');

      const workloadHMAToggle = _.includes(this.props.toggles, 'workloadHMA');

      return (
        <FemaGoTable.Body>
          <FemaGoTable.Row>
            <FemaGoTable.TextCell>
              <Link
                to={
                  workloadHMAToggle && result.subGrantId
                    ? `/subgrant/${result.subGrantId}`
                    : `/grant/${result.grantId}`
                }
                target="_blank"
                title={`${(workloadHMAToggle && result.subGrantId) || result.grantId}`}
              >
                {(workloadHMAToggle && result.subGrantId) || result.grantId}
              </Link>
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {result.followUpRequired == true ? (
                <Popup
                  trigger={<Icon title="Flagged for follow-up" name="flag" />}
                  content="Flagged for follow-up"
                  size="small"
                />
              ) : null}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{fundOppName}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{result.name}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell>
              {moment().diff(moment(result.created), 'days')}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell>{userIdEmail}</FemaGoTable.TextCell>
          </FemaGoTable.Row>
        </FemaGoTable.Body>
      );
    });

    return (
      <React.Fragment>
        <InfiniteScroll
          dataLength={cards.length}
          next={this.props.fetchMoreData}
          hasMore={this.props.hasMore}
          scrollableTarget={'root'}
          loader={
            <Loader inline="centered" active>
              Loading...
            </Loader>
          }
        >
          <FemaGoTable summary="Current Workload">
            <FemaGoTable.Header>
              <FemaGoTable.Row>
                <FemaGoTable.HeaderCell>ID</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell />
                <FemaGoTable.HeaderCell>Funding opportunity</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Task</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Days in queue</FemaGoTable.HeaderCell>
                <FemaGoTable.HeaderCell>Assigned To</FemaGoTable.HeaderCell>
              </FemaGoTable.Row>
            </FemaGoTable.Header>
            {cards}
          </FemaGoTable>
        </InfiniteScroll>
      </React.Fragment>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps)(WorkloadTable);
